import { Directive, Input, OnDestroy, OnInit, ElementRef, Renderer2 } from '@angular/core';

@Directive({
  selector: '[dataMetaDisplay]'
})
export class DataMetaDisplayDirective implements OnInit, OnDestroy {

  @Input() defaultDisplay: string = '-';
  @Input() set dataMetaDisplay(value: string) {
    this._value = value;
    this.setDisplay();
  }

  @Input() set value(value: string) {
    this._value = value;
    this.setDisplay();
  }

  private _value:string;

  constructor(private el: ElementRef,private renderer: Renderer2) {

  }

  ngOnInit(): void {
  }

  private setDisplay():void{
    if(!this._value || (this._value && this._value.length === 0)){
      this.el.nativeElement.innerHTML = this.defaultDisplay;
    }else{
      this.el.nativeElement.innerHTML = this._value;
    }
  }

  ngOnDestroy(): void {

  }

}



// WEBPACK FOOTER //
// /var/lib/jenkins/workspace/pmclient-uat/src/app/shared/directives/data-meta-display.directive.ts